import { useEffect, useState } from 'react'
import { Check, XCircle } from 'lucide-react'
import { api } from '../lib/api'
import type { Actor, Project } from '../lib/types'
import { navigate } from '../lib/router'
import { errorText } from '../components/Toaster'
import { Button, CenterMessage, Notice, Spinner } from '../ds'

export function InviteView({ projectId, actor }: { projectId: string; actor: Actor }) {
  const [project, setProject] = useState<Project | null>(null)
  const [error, setError] = useState('')
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    setLoading(true)
    setError('')
    api
      .acceptProjectInvite(projectId)
      .then((res) => setProject(res.project))
      .catch((err) => setError(errorText(err)))
      .finally(() => setLoading(false))
  }, [projectId])

  if (loading) {
    return (
      <div className="loading-screen">
        <Spinner />
      </div>
    )
  }

  if (error) {
    return (
      <CenterMessage
        wordmark="MENTIONS"
        title="Не удалось принять приглашение"
        sub={`Вы вошли как ${actor.email}. Проверьте, что приглашение отправлено на этот email.`}
        action={
          <div className="stack">
            <Notice>{error}</Notice>
            <Button variant="secondary" onClick={() => navigate('/')}>
              К проектам
            </Button>
          </div>
        }
      />
    )
  }

  return (
    <CenterMessage
      wordmark="MENTIONS"
      title="Приглашение принято"
      sub={project ? `Проект «${project.name}» добавлен в ваш список.` : 'Проект добавлен в ваш список.'}
      action={
        <div className="row">
          <Button onClick={() => project?.id && navigate(`/projects/${project.id}`)}>
            <Check size={16} /> Открыть проект
          </Button>
          <Button variant="secondary" onClick={() => navigate('/')}>
            <XCircle size={16} /> Позже
          </Button>
        </div>
      }
    />
  )
}
